export const CHECKING_STATUS = "checking";
export const CONFIRM_STATUS = "confirm";
export const CANCEL_STATUS = "cancel";
export const MISSED_STATUS = "missed";
export const SUCCESS_STATUS = "success";
